import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { AVAILABILITY_API } from '../api/availability-api'
import { AvailabilityGetInterface } from '../types/availability-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'

export const useGlobalAvailability = (shouldFetch?: boolean) => {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, AvailabilityGetInterface>({
    method: RequestMethodsEnum.get,
  })

  const {
    data: availability,
    mutate,
    isLoading,
  } = useControlledSwr(
    () => {
      if (user) {
        return [
          `${AVAILABILITY_API}?timezone=${user.timezone}`,
          RequestModuleEnum.AvailabilityBookings,
        ]
      }
    },
    fetcher,
    undefined,
    shouldFetch,
  )

  return {
    availability,
    mutate,
    isLoading,
  }
}
